import { lazy } from "react";
import Chat from "../Components/Modules/Panel/chat";
import { pageRoutes } from "./page.routes";
import Invoice from "../Components/Modules/Panel/components/Invoice";

/* Variable Imports like these should be imported at the very end of all other imports */
const Login = lazy(() => import('../Components/Modules/Auth/Login'));
const Dashboard = lazy(() => import('../Components/Modules/Panel/dashboard'));

/* Routes used for Authentication are auth */
/* Routes accessed through Sidebar are primary */
/* All Other Routes are Secondary */

const routes = {
    auth: [
        { path: pageRoutes.login, component: <Login /> },
    ],
    panel: [
        {
            path: pageRoutes.dashboard,
            component: <Dashboard />,
            key: 0,
            label: 'Dashboard',
        },
        {
            path: pageRoutes.chat,
            component: <Chat />,
            key: 0,
            label: 'Chat',
        },
        {
            path: pageRoutes.invoice,
            component: <Invoice />,
            key: 0,
            label: 'Chat',
        },


    ]
}

export {
    routes as DynamicRoutes
}